package songwritersnotebook.app.tutorial

import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.composed
import androidx.compose.ui.layout.boundsInWindow
import androidx.compose.ui.layout.onGloballyPositioned

fun Modifier.tutorialTarget(step: TutorialStep, isSecondary: Boolean = false): Modifier = composed {
    val currentStep by TutorialManager.currentStep.collectAsState()

    if (currentStep == step) {
        Modifier.onGloballyPositioned { coordinates ->
            if (coordinates.isAttached) {
                val rootBounds = coordinates.boundsInWindow()
                if (!rootBounds.left.isNaN() && !rootBounds.top.isNaN()) {
                    TutorialManager.updateTargetRect(step, rootBounds, isSecondary)
                } else {
                    println("DEBUG_UI: NaN detected in tutorial bounds for step $step")
                }
            }
        }
    } else {
        Modifier
    }
}
